// Imports
import firebase from '../config/FirebaseConfig'

// Setup
const db = firebase.firestore()

// Create a searchable field
const create = async (payload, teamId) => {
  const user = firebase.auth().currentUser

  const visibleBy = [user.uid]

  if (teamId) {
    visibleBy.push(`group/${teamId}`)
  }

  await db.collection('search').doc().set({ ...payload, visible_by: visibleBy })
}


// BOARDS SPECIFIC

// Updates a board in the search collection
const updateBoard = async (boardId, payload) => {
  const snapshot = await db.collection('search').where('id', '==', boardId).get()

  return await db
    .collection('search')
    .doc(snapshot.docs[0].id)
    .update(payload)
}

// Deletes a board from the seach collection
const removeBoard = async (boardId) => {
  const snapshot = await db.collection('search').where('id', '==', boardId).get()
  if (snapshot.empty) return

  return db.collection('search').doc(snapshot.docs[0].id).delete()
}

export default {
  create,
  removeBoard,
  updateBoard
}
